/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {getters} from '@/store/modules/community-challenge/getters';
import {actions} from '@/store/modules/community-challenge/actions';
import {mutations} from '@/store/modules/community-challenge/mutations';
import {
    ActiveCommunityChallengeState,
    ActiveCommunityChallengeStateInterface,
} from '@/store/modules/community-challenge/types';

/**
 * The weekly-challenge module.
 * @author Mark Thompson <mthompson@frontier.co.uk>
 */
export const state: ActiveCommunityChallengeStateInterface = new ActiveCommunityChallengeState();

const namespaced: boolean = true;

export const communityChallengeModule: Module<ActiveCommunityChallengeStateInterface, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
